/**
 * Comprueba si un empleado tiene asignación activa al departamento indicado.
 * Soporta tanto factory_department_assignments (labor) como factory_assignments (auth).
 */
export function employeeBelongsToDepartment(emp, departmentId) {
  if (!emp || !departmentId) return false;

  const targetId = Number(departmentId);
  const assignments =
    emp.factory_department_assignments || emp.factory_assignments || [];

  return assignments.some((a) => {
    if (a.active === false) return false;
    const id =
      a.department_id ||
      a.factory_department?.department_id ||
      a.factory_department?.department?.id;
    return id != null && Number(id) === targetId;
  });
}

export function filterEmployeesByDepartment(employees, departmentId) {
  if (!departmentId) return employees;
  return employees.filter((emp) => employeeBelongsToDepartment(emp, departmentId));
}

export function matchesEmployeeSearch(emp, query) {
  if (!query?.trim()) return true;
  const q = query.toLowerCase().trim();
  const first = (emp.first_name || emp.primer_nombre || '').toLowerCase();
  const last = (emp.last_name || emp.apellido_paterno || '').toLowerCase();
  const full = `${first} ${last}`.trim();
  const email = (emp.email || '').toLowerCase();
  return full.includes(q) || first.includes(q) || last.includes(q) || email.includes(q);
}
